import * as React from "react";
import { CennaLogo } from "../primitives/Avatar";
import { ChatSpinner } from "./ui/ChatSpinner";

export type ChatTypingIndicatorProps = {
  /** Inline retry loading (assistant bubble replacement). */
  retrying?: boolean;
};

export const ChatTypingIndicator: React.FC<ChatTypingIndicatorProps> = ({ retrying }) => {
  if (retrying) {
    return (
      <div className="chat-retry-loading" role="status" aria-live="polite">
        <ChatSpinner size="md" />
        <span>Getting a new reply…</span>
      </div>
    );
  }

  return (
    <div className="chat-typing-row" role="status" aria-live="polite">
      <div className="chat-ai-row__logo">
        <CennaLogo size={16} />
      </div>
      <div className="chat-ai-bubble chat-typing">
        <span className="typing-dot" style={{ animationDelay: "0ms" }} />
        <span className="typing-dot" style={{ animationDelay: "150ms" }} />
        <span className="typing-dot" style={{ animationDelay: "300ms" }} />
      </div>
    </div>
  );
};
